import { getTotalPriceText } from "halifax";
import { FiatPrice } from "redmond";

// CT1261T-421: non-blocking inline decrease notice.
export const PRICE_DECREASE_INLINE_MESSAGE = (amount: FiatPrice) =>
  `The price for this stay decreased by ${getTotalPriceText({
    price: amount,
  })} while you were booking.`;
